/** Settings › Preferences: the list's summaries and the Appearance, Sounds, Screen, Updates and Privacy pages. */
export default {
  voiceSummary: "{name}, reads aloud",
  voiceDefaultName: "Default",
  appearanceSummary: "{theme}, {avatars}",
  appearanceSummarySolid: "{theme}, {avatars}, {percent}% solid",
  avatarsSummaryGlass: "shapes",
  avatarsSummaryIcons: "icons",
  pointerSummaryAsk: "Asks first",
  updatesAutomatic: "Automatic",
  updatesManual: "Manual",
  privacySharing: "Sharing selected data",
  privacyUsageOnly: "Usage data only",
  privacyOff: "Nothing shared",
  theme: "Theme",
  themeDark: "Dark",
  themeLight: "Light",
  transparency: "Transparency",
  agentInk: "Agent ink",
  myInk: "My ink",
  inkDenkerGreen: "Denker green",
  inkColor: "Color {color}",
  agentAvatars: "Agent avatars",
  avatarStyleGlass: "Shapes",
  avatarStyleIcons: "Icons",
  notificationSounds: "Notification sounds",
  notificationSoundsDetail: "When a task finishes or needs you",
  sound: "Sound",
  playSound: "Play {sound}",
  volume: "Volume",
  soundChime: "Chime",
  soundPing: "Ping",
  soundBell: "Bell",
  policyAsk: "Ask me each time",
  policyAlways: "Always allow",
  policyNever: "Never allow",
  pointerReadFailed:
    "Could not read the physical pointer preference or macOS permissions.",
  pointerSaveFailed:
    "Could not save the physical pointer preference. Please try again.",
  pointerControl: "Pointer control",
  pointerControlDetail: "When an agent needs to click for you",
  macPermissions: "macOS permissions",
  macPermissionsDetail: "Accessibility and input control",
  notAllowed: "Not allowed",
  allowed: "Allowed",
  openSystemSettings: "Open System Settings",
  pcControl: "Let agents control this PC",
  pcControlDetail: "Mouse, keyboard and screen",
  updateAutomatically: "Update automatically",
  versionAvailable: "{version} is available",
  upToDate: "You’re up to date",
  build: "Build {version}",
  restartToUpdate: "Restart to update",
  checkNow: "Check now",
  privacyIntro:
    "Usage data from your account is on unless you turn it off. The other choices stay off until you turn them on, and apply on this device only. Anonymous usage counts are explained in the privacy policy.",
  usageData: "Usage data",
  usageDataDetail:
    "Helps us see how people use Denker, tied to your account number only. Turn off to stop.",
  usageDataSyncFailed: "Couldn’t sync your usage data choice.",
  productAnalytics: "Product analytics",
  productAnalyticsDetail:
    "Extra detail from this device: feature interactions and technical identifiers, shared with PostHog along with your email and name.",
  errorReports: "Error reports",
  errorReportsDetail:
    "Share optional webview errors and technical details with Sentry.",
  syncScreenshots: "Sync image attachments",
  syncScreenshotsDetail:
    "Keep future image attachments in your account for access on other devices. Off keeps images on this device; chat and canvas keep a reference. Existing images stay where they are. Images you submit to an AI are still sent to that provider.",
  privacyPolicy: "Privacy policy",
  retrySync: "Retry sync",
} as const;
